var FilterType = {
	contractNumber: 'contractNumber',
    nameShop: 'nameShop',
    tradeDate: 'tradeDate',
    operationType: 'operationType',
    sens: 'sens',
    cardType: 'cardType',
    activity : 'activity',
    grossAmount: 'grossAmount',
    COMMISSION: 'commission',
    netAmount: 'netAmount',
    nbTransactions : 'nbTransactions',
    financingDate: 'financingDate'
};

module.exports = FilterType;


// WEBPACK FOOTER //
// ./src/enums/FilterType.js